import axios from '@/lib/axios';
import {useMutation} from '@tanstack/react-query';

/**
 * 0060. サインアウト
 * [DELETE] /sign_out
 */
const SignOut = (): Promise<any> => {
  return axios.delete(`/api/sign_out`);
};

export const useSignOut = () => {
  return useMutation({
    mutationFn: SignOut,
  });
};